export const SCHEDULE_KEY = 'schedule';
export const RECENT_MESSAGE_TIME = `${SCHEDULE_KEY}:recent_message_time`;
export const SELECTED_SCHEDULES = `${SCHEDULE_KEY}:selected_schedules`;
export const CURRENT_SCHEDULE = `${SCHEDULE_KEY}:current_schedule`;
